import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { col4, col6 } from "../../../common/utils";
import { MeasurableValueDTO } from "../../../datasources/api-client/data-contracts";
import NumericValueWidget from "../../charts/NumericValueWidget";

type Props = {
	bio?: MeasurableValueDTO | null;
	pmx?: MeasurableValueDTO | null;
	pmxCoverage?: MeasurableValueDTO | null;
	bioCoverage?: MeasurableValueDTO | null;
	loading?: boolean;
	onReload?: VoidFunction;
};

export const AmbientalKpiWidget = ({ bio, pmx, loading, onReload, pmxCoverage, bioCoverage }: Props) => {
	const { t } = useTranslation("common");
	return (
		<Grid container spacing={2} width={"100%"} pt={2}>
			<Grid size={12}>
				<Typography variant="h5">{t("environmental kpis")}</Typography>
			</Grid>
			<Grid size={pmx ? col4 : col6} minHeight={120}>
				<NumericValueWidget
					title={t("biogenic emissions")}
					isLoading={loading}
					onReload={onReload}
					value={bio?.value}
					measure={bio?.measure || "TBD"}
					coverage={bioCoverage}
				/>
			</Grid>
			<Grid size={pmx ? col4 : col6} minHeight={120}>
				<NumericValueWidget title={t("ghg components")} measure={"TBD"} />
			</Grid>
			{pmx && (
				<Grid size={col4} minHeight={120}>
					<NumericValueWidget
						title={t("pmx")}
						isLoading={loading}
						onReload={onReload}
						value={pmx?.value}
						measure={pmx?.measure || "TBD"}
						coverage={pmxCoverage}
					/>
				</Grid>
			)}
		</Grid>
	);
};
